/**
 * The interaction state of a fillable element, resolved once from the three
 * inputs the renderers previously combined ad-hoc (which had drifted — e.g. the
 * dropdown derived "controlled" differently from text/checkbox):
 *
 *  - `inert`      — not in fill mode: the editor design view (placeholder/sample).
 *  - `controlled` — fill mode + an `onFillChange` sink: capture the worker's answer.
 *  - `preview`    — fill mode, no sink: the editor's preview toggle (uncontrolled,
 *                   seeded with defaults, never persisted).
 *  - `readonly`   — fill mode + `fillReadOnly`: show the captured value, disabled
 *                   (the completed-job report view).
 */
export type FillMode = 'inert' | 'controlled' | 'preview' | 'readonly';

export function resolveFillMode(opts: {
  fillMode: boolean;
  /** Whether an `onFillChange` sink is wired (interactive capture). */
  hasOnChange: boolean;
  fillReadOnly: boolean;
}): FillMode {
  if (!opts.fillMode) return 'inert';
  if (opts.fillReadOnly) return 'readonly';
  return opts.hasOnChange ? 'controlled' : 'preview';
}
